import { render, staticRenderFns } from "./RowChild.vue?vue&type=template&id=0f8fc15a&scoped=true&"
import script from "./RowChild.vue?vue&type=script&lang=js&"
export * from "./RowChild.vue?vue&type=script&lang=js&"
import style0 from "./RowChild.vue?vue&type=style&index=0&id=0f8fc15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8fc15a",
  null
  
)

export default component.exports